/**
 * @module components\ghModelView\propView\templates\selection
 */
import Vue from "vue";
import Component from "vue-class-component";
import Base from "./../../base";
import { MethodService } from "@/utils/serviceModel";
import { State, namespace, Action, Getter } from "vuex-class";
import { Watch } from "vue-property-decorator";

const module = namespace("dbModule");

@Component
export default class Selection extends Base {
  @module.State(state => state.columnsSource)
  private sources: IndexObject;
  @module.State(state => state.currentId)
  private currentChangeTableId;

  @module.Getter("column")
  private column;

  @module.Action("fetchColumnSource")
  private fetch;

  private setSource;

  private selfItems = [];

  private get items() {
    return this.column(this.prop.Id).dataSource;
  }

  @Watch("model")
  private intial() {
    if (this.model) {
      if (!this.model[this.prop.value]) {
        this.$set(this.model, this.prop.value, null);
      }
    }
  }

  @Watch("currentChangeTableId")
  private intialSource() {
    let s: IndexObject = this.column(this.prop.Id);
    if (!s || (s.dataSource && s.dataSource.length === 0)) {
      this.refresh();
    }
  }

  private get loading() {
    return this.column(this.prop.Id).loading;
  }

  created() {
    this.intial();
    this.intialSource();
  }

  mounted() {}

  private refresh() {
    if (this.prop.Id) {
      this.fetch(this.prop.Id);
    }
  }

  private update(args) {
    if (this.prop.sourceItemValue && this.prop.valueColumn) {
      let value = args[this.prop.sourceItemValue];
      this.model[this.prop.valueColumn] = value;
      
      
    }
    if (this.prop.sourceItemText && this.prop.textColumn) {
      let text = args[this.prop.sourceItemText];
      this.model[this.prop.textColumn] = text;
      
    }
  }
}
